import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutContactFormService } from '@checkout/feature';

@Component({
  selector: 'sd-submit-order',
  templateUrl: './submit-order.component.html',
  styleUrls: ['./submit-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorSubmitOrderComponent {
  constructor(public checkoutContactFormService: CheckoutContactFormService) {}
}
